import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import PopupSelect from '../mypage/popup_select/PopupSelect';
import PopupOptions from '../mypage/popup_select/popup_select_component/PopupOptions';
import 'slick-carousel'
import 'magnific-popup'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'react-app-polyfill/ie11'


class BasicInformationEditor extends React.Component {
  render() {
    // ViewModeコンポーネントに、Rails View の 'react_component' タグで引き渡されたデータを渡す
    // （これらのデータは、それぞれのコンポーネントで 'props' 経由でアクセスできる）
    return (
      <ViewMode
        member={this.props.member}
        member_areas={this.props.member_areas}
        errors={this.props.errors}
        update_url={this.props.update_url}
        csrf_token={this.props.csrf_token}
      />
    );
  }
}

class ViewMode extends React.Component {
  // コンストラクタ
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    // デフォルト動作の解除
    e.preventDefault();
    // メッセージエリアをクリア
    var message_area = document.querySelector('div.message_area.profile');
    while (message_area.firstChild) {
      message_area.removeChild(message_area.firstChild);
    }
    // 編集モードに遷移
    ReactDOM.render(
      <EditMode
        member={this.props.member}
        member_areas={this.props.member_areas}
        errors={{ nickname: '', name: '', office_division_etc: '', form_division_etc: '', office_name: '', homepage_base: '', contract_form_etc: '' }}
        update_url={this.props.update_url}
        csrf_token={this.props.csrf_token}
      />,
      document.getElementById('basic_information_area')
    );
  }

  render() {
    function OpenRangeTag(props) {
      if (props.value == 1) {
        return <span className="release_on fs-75">全体に公開</span>
      } else if (props.value == 2) {
        return <span className="release_on fs-75">仲間にのみ公開</span>
      } else if (props.value == 3) {
        return <span className="release_off fs-75">公開しない</span>
      } else {
        return <span className="release_off fs-75"></span>
      }
    }
    function BirthDateValue(props) {
      if (props.value) {
        var birth_date = new Date(props.value);
        var today = new Date();
        var last_birth_date = new Date(today.getFullYear(), birth_date.getMonth(), birth_date.getDate());
        return birth_date.getFullYear() + '年' + (birth_date.getMonth() + 1) + '月' + birth_date.getDate() + '日　（' + (last_birth_date.getFullYear() - birth_date.getFullYear()) + '歳）';
      } else {
        return '';
      }
    }
    function GenderValue(props) {
      if (props.value == 1) {
        return '男性';
      } else if (props.value == 2) {
        return '女性';
      } else {
        return '';
      }
    }
    function MemberAreasValue(props) {
      var values = props.member_areas.map(r => r.name);
      return (values.length === 0 ? 'なし' : values.join('/'));
    }
    function OfficeDivisionValue(props) {
      if (props.value == 1) {
        return '法人事業所';
      } else if (props.value == 2) {
        return '個人事業所';
      } else if (props.value == 99) {
        return 'その他　' + props.etc;
      } else {
        return '設定なし';
      }
    }
    function FormDivisionValue(props) {
      if (props.value == 1) {
        return '代表者（事業主）';
      } else if (props.value == 2) {
        return '役員';
      } else if (props.value == 3) {
        return '従業員';
      } else if (props.value == 4) {
        return '一人親方';
      } else if (props.value == 99) {
        return 'その他　' + props.etc;
      } else {
        return '設定なし';
      }
    }
    function ContractFormValue(props) {
      if (props.value == 1) {
        return '来所';
      } else if (props.value == 2) {
        return '訪問';
      } else if (props.value == 3) {
        return '電話';
      } else if (props.value == 4) {
        return 'ＦＡＸ';
      } else if (props.value == 5) {
        return 'メール';
      } else if (props.value == 99) {
        return 'その他　' + props.etc;
      } else {
        return '設定なし';
      }
    }
    return (
      <React.Fragment>
        <div className="basic">
          <h3 className="fs-113">基本情報</h3>
          <div className="btn_right edit mypage_basic"><a href="" className="fs-75 btn_target" onClick={this.handleClick}>編集する</a></div>
          <table className="edit">
            <tbody>
              <tr>
                <th>ニックネーム</th>
                <td>{this.props.member.nickname}</td>
              </tr>
              <tr>
                <th>名前</th>
                <td><p className="mypage_info_area_width">{this.props.member.name}</p><OpenRangeTag value={this.props.member.name_open_range} /></td>
              </tr>
              <tr>
                <th>生年月日</th>
                <td><BirthDateValue value={this.props.member.birth_date} /><OpenRangeTag value={this.props.member.birth_date_open_range} /></td>
              </tr>
              <tr>
                <th>年齢</th>
                <td>{this.props.member.generation}<OpenRangeTag value={this.props.member.generation_open_range} /></td>
              </tr>
              <tr>
                <th>性別</th>
                <td><GenderValue value={this.props.member.gender} /><OpenRangeTag value={this.props.member.gender_open_range} /></td>
              </tr>
              <tr>
                <th>活動地域</th>
                <td><MemberAreasValue member_areas={this.props.member_areas} /></td>
              </tr>
              <tr>
                <th>事業所区分</th>
                <td><OfficeDivisionValue value={this.props.member.office_division} etc={this.props.member.office_division_etc} /></td>
              </tr>
              <tr>
                <th>形態区分</th>
                <td><FormDivisionValue value={this.props.member.form_division} etc={this.props.member.form_division_etc} /></td>
              </tr>
              <tr>
                <th>事業所名（屋号）</th>
                <td>{this.props.member.office_name}</td>
              </tr>
              <tr>
                <th>ホームページ</th>
                <td><a href={this.props.member.homepage_base} target="_blank" rel="noopener noreferrer">{this.props.member.homepage_base}</a></td>
              </tr>
              <tr>
                <th>受発注（請負形態）</th>
                <td><ContractFormValue value={this.props.member.contract_form} etc={this.props.member.contract_form_etc} /></td>
              </tr>
            </tbody>
          </table>
          <h4 className="fs-113 title_bottom">基本情報</h4>
          <div className="btn_right_bottom edit mypage_basic"><a href="" className="fs-75 btn_target" onClick={this.handleClick}>編集する</a></div>
        </div>
      </React.Fragment>
    );
  }
}

class EditMode extends React.Component {
  // コンストラクタ
  constructor(props) {
    super(props);
    this.state = {
      member: JSON.parse(JSON.stringify(this.props.member)),
      member_areas: JSON.parse(JSON.stringify(this.props.member_areas))
    };
    this.selectedAreas = React.createRef();
    this.handleClick = this.handleClick.bind(this);
    this.handleClickMemberAreas = this.handleClickMemberAreas.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeSelectedAreas = this.handleChangeSelectedAreas.bind(this);
  }

  componentDidMount() {
    this.$selectedAreas = $(this.selectedAreas);
    this.$selectedAreas.on('change', this.handleChangeSelectedAreas);
  }

  componentWillUnmount() {
    this.$selectedAreas.off('change', this.handleChangeSelectedAreas);
  }

  handleClick(e) {
    // デフォルト動作の解除
    e.preventDefault();
    // ボタン非活性
    let elements = document.querySelectorAll('.btn_target');
    elements.forEach(function (element) {
      element.classList.add('btn_disabled');
    });
    // membersの更新
    fetch(this.props.update_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.props.csrf_token
      },
      body: JSON.stringify({
        member: {
          nickname: this.state.member.nickname,
          name: this.state.member.name,
          name_open_range: this.state.member.name_open_range,
          generation: this.state.member.generation,
          generation_open_range: this.state.member.generation_open_range,
          gender_open_range: this.state.member.gender_open_range,
          office_division: this.state.member.office_division,
          office_division_etc: this.state.member.office_division_etc,
          form_division: this.state.member.form_division,
          form_division_etc: this.state.member.form_division_etc,
          office_name: this.state.member.office_name,
          homepage_base: this.state.member.homepage_base,
          contract_form: this.state.member.contract_form,
          contract_form_etc: this.state.member.contract_form_etc
        },
        member_areas: this.state.member_areas,
        authenticity_token: this.props.csrf_token
      })
    }).then((res) => {
      return res.json();
    }).then((data) => {
      // メッセージエリアをクリア
      var message_area = document.querySelector('div.message_area.profile');
      while (message_area.firstChild) {
        message_area.removeChild(message_area.firstChild);
      }
      if (data.status == 200) {
        // ViewModeを再表示
        ReactDOM.render(
          <ViewMode
            member={this.state.member}
            member_areas={this.state.member_areas}
            errors={this.props.errors}
            update_url={this.props.update_url}
            csrf_token={this.props.csrf_token}
          />,
          document.getElementById('basic_information_area')
        );
        // 変更された項目があるとき
        if (Object.keys(data.saved_changes).length !== 0) {
          // 更新メッセージ表示
          const node = document.createElement('p');
          const message = document.createTextNode('プロフィールを更新しました。');
          node.appendChild(message);
          document.querySelector('div.message_area.profile').appendChild(node);
          // ページ上部の「活動地域」を更新
          var content = this.state.member_areas.map(r => r.name).join('/');
          if (content.length === 0) { content = 'なし' }
          $('#mypage_area dl.industry_list dd#areas').text(content);
          // 「プロフィール完成度」を更新
          if (data.saved_changes.profile_completeness) {
            $('div.chart_area dl dd.chart p span').css('display', 'none');
            $('div.chart_area dl dd.chart p').css('width', '0px');
            $('div.chart_area dl dd.chart p').animate({ width: data.saved_changes.profile_completeness[1] + '%' }, 1000, 'swing', function () { $('div.chart_area dl dd.chart p span').css('display', 'block') });
            $('div.chart_area dl dd.chart p span b').text(data.saved_changes.profile_completeness[1]);
          }
        }
      } else if (data.status == 400) {
        // EditModeを再表示
        ReactDOM.render(
          <EditMode
            member={JSON.parse(JSON.stringify(this.state.member))}
            member_areas={JSON.parse(JSON.stringify(this.state.member_areas))}
            errors={data.errors}
            update_url={this.props.update_url}
            csrf_token={this.props.csrf_token}
          />,
          document.getElementById('basic_information_area')
        );
        // エラーメッセージ表示
        const node = document.createElement('p');
        const message = document.createTextNode('入力内容にエラーがあります。');
        node.appendChild(message);
        document.querySelector('div.message_area.profile').appendChild(node);
      }
      // ボタン活性
      let elements = document.querySelectorAll('.btn_target');
      elements.forEach(function (element) {
        element.classList.remove('btn_disabled');
      });
    }).catch((err) => {
      console.error(err);
    });
  }

  // 活動地域
  async handleClickMemberAreas(e) {
    e.preventDefault();

    const url = (() => {
      // URLを作成する
      const path = '/popup/member_areas';
      const data = { selected_ids: this.state.member_areas.map(r => r.id) };
      return path + '?' + (new URLSearchParams(data)).toString();
    })();

    const data = await fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(response => {
      return response.json();
    }).then(result => {
      if (result.status === 200) {
        return result.data;
      } else {
        throw new Error("status is not 200");
      }
    }).catch(error => {
      console.error(new Error(error.message));
      alert('項目の取得中にエラーが発生しました。');
    });

    const onClosePopup = (selectedAreas) => {
      this.setState({ member_areas: selectedAreas });
      $(this.selectedAreas).val(selectedAreas);
    };

    const rootNode = document.querySelector('#popup_industry');
    const ButtonArea = props => {
      return <a className="select select-area-btn" onClick={props.onClickCloseButton}>選択</a>
    };
    ReactDOM.render(
      <PopupSelect
        popupOptions={PopupOptions.areas}
        sectionTypes={data.sectionTypes}
        itemTypes={data.itemTypes}
        isLimitedItem={data.isLimitedItem}
        selectedIds={data.selectedIds.map(Number)}
        onClosePopup={onClosePopup}
        ButtonArea={ButtonArea}
        needSelectedAllButton={true}
        rootNode={rootNode}
      />, rootNode
    );
  }

  handleChange(e) {
    var member = this.state.member;
    switch (e.target.id) {
      case 'nickname':
        member.nickname = e.target.value;
        break;
      case 'name':
        member.name = e.target.value;
        break;
      case 'name_open_range':
        member.name_open_range = e.target.value;
        break;
      case 'generation':
        member.generation = e.target.value;
        break;
      case 'generation_open_range':
        member.generation_open_range = e.target.value;
        break;
      case 'gender_open_range':
        member.gender_open_range = e.target.value;
        break;
      case 'office_division':
        member.office_division = e.target.value;
        if (member.office_division != 99) {
          member.office_division_etc = '';
        }
        break;
      case 'office_division_etc':
        member.office_division_etc = e.target.value;
        break;
      case 'form_division':
        member.form_division = e.target.value;
        if (member.form_division != 99) {
          member.form_division_etc = '';
        }
        break;
      case 'form_division_etc':
        member.form_division_etc = e.target.value;
        break;
      case 'office_name':
        member.office_name = e.target.value;
        break;
      case 'homepage_base':
        member.homepage_base = e.target.value;
        break;
      case 'contract_form':
        member.contract_form = e.target.value;
        if (member.contract_form != 99) {
          member.contract_form_etc = '';
        }
        break;
      case 'contract_form_etc':
        member.contract_form_etc = e.target.value;
    }
    // 状態を更新
    this.setState({ member: member });
  }

  handleChangeSelectedAreas(e) {
    var selected_areas_value = '[]';
    if (e.target.value) {
      selected_areas_value = JSON.parse(e.target.value);
    }
    this.setState({ member_areas: selected_areas_value });
  }

  render() {
    function ErrorMessageTag(props) {
      if (props.item == '全体' && props.message) {
        return <div className="error_massage none_markup">エラー項目があります。</div>;
      } else if (props.item && props.message) {
        return <div className="error_massage">{props.item}{props.message}</div>;
      } else if (props.message) {
        return <div className="error_massage">{props.message}</div>;
      } else {
        return '';
      }
    }
    function OpenRangeTag(props) {
      if (props.value == 1) {
        return <span className="release_on fs-75">全体に公開</span>
      } else if (props.value == 2) {
        return <span className="release_on fs-75">仲間にのみ公開</span>
      } else if (props.value == 3) {
        return <span className="release_off fs-75">公開しない</span>
      } else {
        return <span className="release_off fs-75"></span>
      }
    }
    function BirthDateValue(props) {
      if (props.value) {
        var birth_date = new Date(props.value);
        var today = new Date();
        var last_birth_date = new Date(today.getFullYear(), birth_date.getMonth(), birth_date.getDate());
        return birth_date.getFullYear() + '年' + (birth_date.getMonth() + 1) + '月' + birth_date.getDate() + '日　（' + (last_birth_date.getFullYear() - birth_date.getFullYear()) + '歳）';
      } else {
        return '';
      }
    }
    function GenderValue(props) {
      if (props.value == 1) {
        return '男性';
      } else if (props.value == 2) {
        return '女性';
      } else {
        return '';
      }
    }
    return (
      <React.Fragment>
        <div className="basic input_group_area">
          <h3 className="fs-113">基本情報</h3>
          <div className="btn_right mypage_basic"><a href="" className="fs-75 btn_target" onClick={this.handleClick}>更新</a></div>
          <ErrorMessageTag item={'全体'} message={this.props.errors ? Object.values(this.props.errors).join('') : ''} />
          <table className="edit">
            <tbody>
              <tr>
                <th>ニックネーム<span className="required">(必須)</span></th>
                <td>
                  <ErrorMessageTag item={'ニックネーム'} message={this.props.errors.nickname} />
                  <input id="nickname" type="text" maxLength="10" value={this.state.member.nickname} onChange={this.handleChange} className={this.props.member.nickname ? "w50 col1 completed" : "w50 col1"} />
                </td>
              </tr>
              <tr>
                <th>名前<span className="required">(必須)</span></th>
                <td>
                  <ErrorMessageTag item={'名前'} message={this.props.errors.name} />
                  <input id="name" type="text" maxLength="80" value={this.state.member.name} onChange={this.handleChange} className={this.props.member.name ? "w50 col1 completed" : "w50 col1"} />
                  <select id="name_open_range" value={this.state.member.name_open_range} onChange={this.handleChange} className={this.props.member.name_open_range ? "col1 completed" : "col1"}>
                    <option value="1">全体に公開する</option>
                    <option value="2">仲間にのみ公開</option>
                    <option value="3">公開しない</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>生年月日</th>
                <td><BirthDateValue value={this.props.member.birth_date} /><OpenRangeTag value={this.props.member.birth_date_open_range} /></td>
              </tr>
              <tr>
                <th>年齢</th>
                <td>
                  <ErrorMessageTag item={'年齢'} message={this.props.errors.generation} />
                  <input id="generation" type="text" maxLength="20" value={this.state.member.generation} onChange={this.handleChange} className={this.props.member.generation ? "w50 col1 completed" : "w50 col1"} />
                  <select id="generation_open_range" value={this.state.member.generation_open_range} onChange={this.handleChange} className={this.props.member.generation_open_range ? "col1 completed" : "col1"}>
                    <option value="1">全体に公開する</option>
                    <option value="2">仲間にのみ公開</option>
                    <option value="3">公開しない</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>性別</th>
                <td>
                  <span className="gender"><GenderValue value={this.props.member.gender} />
                    <select id="gender_open_range" value={this.state.member.gender_open_range} onChange={this.handleChange} className={this.props.member.gender_open_range ? "col1 completed" : "col1"}>
                      <option value="1">全体に公開する</option>
                      <option value="2">仲間にのみ公開</option>
                      <option value="3">公開しない</option>
                    </select>
                  </span>
                </td>
              </tr>
              <tr>
                <th>活動地域<span className="required">(必須)</span></th>
                <td>
                  <ErrorMessageTag item={'活動地域'} message={this.props.errors.member_areas} />
                  <a href="" className="inline_link area" data-id="area" onClick={this.handleClickMemberAreas}>
                    <input type="text" className={this.props.member_areas.length !== 0 ? "w100 area completed" : "w100 area"} value={this.state.member_areas.map(r => r.name).join('/')} placeholder={'活動地域を選択'} readOnly />
                  </a>
                  <input type="hidden" id="selected_areas" ref={selectedAreas => this.selectedAreas = selectedAreas} />
                </td>
              </tr>
              <tr>
                <th>事業所区分</th>
                <td className="fixex_textbox">
                  <ErrorMessageTag item={'事業所区分（その他）'} message={this.props.errors.office_division_etc} />
                  <select id="office_division" value={this.state.member.office_division} onChange={this.handleChange} className={this.props.member.office_division ? "col2 completed" : "col2"}>
                    <option value="0">設定なし</option>
                    <option value="1">法人事業所</option>
                    <option value="2">個人事業所</option>
                    <option value="99">その他</option>
                  </select>
                  <input id="office_division_etc" type="text" maxLength="100" value={this.state.member.office_division_etc} onChange={this.handleChange} className={this.props.member.office_division_etc ? "w50 col1 completed" : "w50 col1"} disabled={this.state.member.office_division == 99 ? '' : 'disabled'} />
                </td>
              </tr>
              <tr>
                <th>形態区分</th>
                <td className="fixex_textbox">
                  <ErrorMessageTag item={'形態区分（その他）'} message={this.props.errors.form_division_etc} />
                  <select id="form_division" value={this.state.member.form_division} onChange={this.handleChange} className={this.props.member.form_division ? "col2 completed" : "col2"}>
                    <option value="0">設定なし</option>
                    <option value="1">代表者（事業主）</option>
                    <option value="2">役員</option>
                    <option value="3">従業員</option>
                    <option value="4">一人親方</option>
                    <option value="99">その他</option>
                  </select>
                  <input id="form_division_etc" type="text" maxLength="100" value={this.state.member.form_division_etc} onChange={this.handleChange} className={this.props.member.form_division_etc ? "w50 col1 completed" : "w50 col1"} disabled={this.state.member.form_division == 99 ? '' : 'disabled'} />
                </td>
              </tr>
              <tr>
                <th>事業所名（屋号）</th>
                <td>
                  <ErrorMessageTag item={'事業所名（屋号）'} message={this.props.errors.office_name} />
                  <input id="office_name" type="text" maxLength="100" value={this.state.member.office_name} onChange={this.handleChange} className={this.props.member.office_name ? "w100 completed" : "w100"} />
                </td>
              </tr>
              <tr>
                <th>ホームページ</th>
                <td>
                  <ErrorMessageTag item={'ホームページ'} message={this.props.errors.homepage_base} />
                  <input id="homepage_base" type="text" maxLength="1024" value={this.state.member.homepage_base} onChange={this.handleChange} className={this.props.member.homepage_base ? "w100 completed" : "w100"} />
                </td>
              </tr>
              <tr>
                <th>受発注（請負）形態</th>
                <td className="fixex_textbox">
                  <ErrorMessageTag item={'受発注（請負）形態（その他）'} message={this.props.errors.contract_form_etc} />
                  <select id="contract_form" value={this.state.member.contract_form} onChange={this.handleChange} className={this.props.member.contract_form ? "col2 completed" : "col2"}>
                    <option value="0">設定なし</option>
                    <option value="1">来所</option>
                    <option value="2">訪問</option>
                    <option value="3">電話</option>
                    <option value="4">ＦＡＸ</option>
                    <option value="5">メール</option>
                    <option value="99">その他</option>
                  </select>
                  <input id="contract_form_etc" type="text" maxLength="100" value={this.state.member.contract_form_etc} onChange={this.handleChange} className={this.props.member.contract_form_etc ? "w50 col1 completed" : "w50 col1"} disabled={this.state.member.contract_form == 99 ? '' : 'disabled'} />
                </td>
              </tr>
            </tbody>
          </table>
          <h4 className="fs-113 title_bottom">基本情報</h4 >
          <div className="btn_right_bottom"><a href="" className="fs-75 btn_target" onClick={this.handleClick}>更新</a></div>
        </div>
      </React.Fragment>
    );
  }
}

BasicInformationEditor.propTypes = { member: PropTypes.object }

export default BasicInformationEditor
